import { Reveal, Overline } from "../Reveal";
import { ASSETS } from "../assets";

export default function Slide05Hero() {
  return (
    <section className="slide bg-[var(--ais-cream-2)]" data-testid="slide-05">
      <div className="grid grid-cols-1 md:grid-cols-12 min-h-screen">
        <div className="md:col-span-7 relative min-h-[55vh] md:min-h-screen bg-[var(--ais-cream-2)] overflow-hidden flex items-center justify-center">
          <img
            src={ASSETS.yellowMocassinsModel}
            alt="AIS — Mocassino Gommino in yellow suede, Gulf marina"
            className="w-full h-full object-contain kenburns"
          />
        </div>

        <div className="md:col-span-5 flex items-center bg-[var(--ais-cream)] py-24">
          <div className="px-6 md:px-14 max-w-md">
            <Reveal>
              <Overline>05 — Hero Collection</Overline>
            </Reveal>
            <Reveal delay={1}>
              <div className="hairline w-12 my-7" />
            </Reveal>
            <Reveal delay={2}>
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[var(--ais-espresso)] leading-[1.08] tracking-[-0.01em] font-light">
                Velo
                <br />
                <em className="italic">Loafer</em>.
              </h2>
            </Reveal>
            <Reveal delay={3}>
              <p className="mt-8 font-sans text-[var(--ais-text)] text-base leading-[1.85] font-light">
                The signature silhouette of the house. Built around carefully
                selected top-quality leathers, finished with the rubber-pebble
                sole that defines the gommino tradition.
              </p>
            </Reveal>

            <div className="mt-10 space-y-5">
              {[
                {
                  k: "Profiles",
                  v: "Loafers · Mocassino",
                },
                {
                  k: "Leathers",
                  v: "Selected calf · Suede · Nappa",
                },
                {
                  k: "Colourways",
                  v: "Blue · Espresso · Ivory · Beige · White · & more",
                },
                { k: "Sizing", v: "EU 35 — 42 · Half sizes available" },
              ].map((r, i) => (
                <Reveal key={r.k} delay={4 + i}>
                  <div className="flex justify-between gap-4 border-b border-[var(--ais-gold-soft)] pb-4">
                    <span className="font-sans text-[0.65rem] tracking-luxe uppercase text-[var(--ais-leather)] shrink-0">
                      {r.k}
                    </span>
                    <span className="font-serif italic text-[var(--ais-espresso)] text-base text-right">
                      {r.v}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
